<template>     
    <div id="eartag-info" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('eartag.Eartag_info') }}</h5>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('eartag.Name') }}:</label>
              <div class="display-field">{{ state.name }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('eartag.Abbreviation') }}</label>
              <div class="display-field">{{ state.abbreviation }}</div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
            <div class="col-6">
              <div class="input-group input-group-static null">
                <label class="">{{ $t('eartag.Chamber_of_commerce_no') }}</label>
                <div class="display-field">{{ state.chamberOfCommerceNo }}</div>                
              </div>
            </div>
            <div class="col-6">
              <div class="input-group input-group-static null">
                  <label class="">{{ $t('eartag.Phone_number') }} / {{ $t('eartag.Mobile_number') }}</label>
                  <div class="display-field">{{ state.phoneNumber }}</div>                  
              </div>
            </div>
        </div>        
      </div>
    </div>    
    <div id="delete" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('eartag.Delete_eartag') }}</h5>
        <p class="text-sm mb-0">
          {{ $t('common.Once_you_delete_there_is_no_going_back_Please_be_certain') }}
        </p>
      </div>
      <div class="card-body d-sm-flex pt-0">
        <div class="d-flex align-items-center mb-sm-0 mb-4">
          <div>
            <material-switch id="deleteEartag" name="Delete Eartag" @click="confirmDelete"/>
          </div>
          <div class="ms-2">
            <span class="text-dark font-weight-bold d-block text-sm">{{ $t('common.Confirm') }}</span>
            <span class="text-xs d-block">{{ $t('common.Delete_for') }} {{ state.name }}.</span>
          </div>
        </div>        
        <button class="btn mb-0 bg-gradient-danger btn-sm null null mb-0 ms-2" type="button" :disabled="!state.deleteEartag" @click="deleteEartag" name="button">{{ $t('eartag.Delete_eartag') }}</button>
      </div>
    </div>
</template>

<script>
  import MaterialSwitch from "@/components/MaterialSwitch.vue";
  import axios from 'axios'
  import { reactive } from 'vue'  

  export default {
    name: "EartagOverview",
    setup() {
      const state = reactive ({
          eartag: [],          
          gets: [],
          id: '',
          tagUbn: '',
          countryCode: '',
          tagNumber: '',
          workNumber: '',
          manufactureCode: '',
          manufacturerName: '',
          codeTagType: '',
          descriptionTagType: '',
          codeTagKind: '',
          codeTagShape: '',
          descriptionTagShape: '',
          supplier: '',
          supplieDate: null,
          deleteEartag: false,
      })
      return {
          state
      }
    },    
    components: {     
      MaterialSwitch, 
    },
    data() {
      return {
        eartag: [],
        gets: [],
      };
    },
    async mounted() {  
      this.id = this.$route.params.id;    
      await this.fetchEartagData(this.$route.params.id);      
    },
    methods: {      
      async fetchEartagData(eartagId) {
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.get(`Eartag/${eartagId}`);
            this.gets = response.data;

            if (this.gets.success) {
                this.state.eartag = this.gets.data;

                this.state.id = this.state.eartag.id;
                this.state.tagUbn = this.state.eartag.tagUbn;
                this.state.countryCode = this.state.eartag.countryCode || '\u00A0';
                this.state.tagNumber = this.state.eartag.tagNumber;
                this.state.workNumber = this.state.eartag.workNumber || '\u00A0';
                this.state.manufactureCode = this.state.eartag.manufactureCode || '\u00A0';
                this.state.manufacturerName = this.state.eartag.manufacturerName || '\u00A0';
                this.state.codeTagType = this.state.eartag.codeTagType || '\u00A0';
                this.state.descriptionTagType = this.state.eartag.descriptionTagType || '\u00A0';
                this.state.codeTagKind = this.state.eartag.codeTagKind || '\u00A0';
                this.state.codeTagShape = this.state.eartag.codeTagShape || '\u00A0';
                this.state.descriptionTagShape = this.state.eartag.descriptionTagShape || '\u00A0';
                this.state.supplier = this.state.eartag.supplier;
                this.state.supplieDate = this.state.eartag.supplieDate;

            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      confirmDelete() {
        this.state.deleteEartag = !this.state.deleteEartag;
      },      
      deleteEartag() {
        if (this.state.deleteEartag) {
          this.deleteEartag1(this.state.id)
        }
      },                  
      async deleteEartag1(id) {   
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.delete("eartag/" + id);
            this.gets = response.data;

            if (this.gets.success) {
              this.$showSuccess('errors.Success_eartag_deleted_successfully');              
              this.$router.push('/eartag');
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }         
      }
    }
  };
</script>
<style scoped>

.display-field {
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #4ca750;
  padding: 2px 0;
  margin-top: 2px;
  background-color: transparent;  
  font-size: 0.875rem;
}

  .card-shadow-all {
    box-shadow: 0 0 20px 4px rgba(0, 0, 0, 0.1);
  }

  .card-body .input-group-static {
    margin-bottom: 5px;
  }

  .card-body .form-control {
    padding: 8px;    
    border-radius: 4px;
  }

  .card-body label {  
    font-size: 0.875rem;
    font-weight: 400;
    color: #7b809a;
  }

  .font-size-18 {
    font-size: 18px !important;
  }
</style>